const WCS_30 = [
  0,
  0, // C1–C2
  0.01,
  0.01, // C3–C4
  0.02,
  0.02, // C5–C6
  0.02,
  0.02, // C7–C8
  0.03,
  0.03,
  0.03,
  0.03, // C9–C12
  0.04,
  0.04,
  0.04,
  0.04, // C13–C16
  0.05,
  0.05,
  0.05,
  0.05, // C17–C20
  0.05,
  0.05,
  0.05,
  0.05, // C21–C25
  0.05,
  0.05,
  0.05,
  0.05, // C26–C35
  0.04,
  0.04, // C36+
];

// Normalize to ensure sum = 1
const sum = WCS_30.reduce((a, b) => a + b, 0);
const WCS_30_norm = WCS_30.map((v) => v / sum);

const VenezuelanHeavy_30 = [
  0,
  0, // C1–C2
  0.005,
  0.005, // C3–C4
  0.01,
  0.01, // C5–C6
  0.015,
  0.015, // C7–C8
  0.02,
  0.02,
  0.02,
  0.02, // C9–C12
  0.03,
  0.03,
  0.03,
  0.03, // C13–C16
  0.04,
  0.04,
  0.04,
  0.04, // C17–C20
  0.06,
  0.06,
  0.06,
  0.06, // C21–C25
  0.07,
  0.07,
  0.07,
  0.07, // C26–C29
  0.08,
  0.08, // C30+
];

// Normalize
const sumVen = VenezuelanHeavy_30.reduce((a, b) => a + b, 0);
const VenezuelanHeavy_30_norm = VenezuelanHeavy_30.map((v) => v / sumVen);

function makeLightCrude(baseWeights) {
  // baseWeights: an array of 30 floats before normalization
  const sum = baseWeights.reduce((a, b) => a + b, 0);
  return baseWeights.map((v) => v / sum);
}

const Brent_30 = makeLightCrude([
  0,
  0, // C1–C2
  0.005,
  0.005, // C3–C4
  0.02,
  0.02, // C5–C6
  0.03,
  0.03, // C7–C8
  0.04,
  0.04,
  0.04,
  0.04, // C9–C12
  0.05,
  0.05,
  0.05,
  0.05, // C13–C16
  0.06,
  0.06,
  0.06,
  0.06, // C17–C20
  0.05,
  0.05,
  0.05,
  0.05, // C21–C25
  0.04,
  0.04,
  0.03,
  0.03, // C26–C30
  0.02,
  0.02, // C31+
]);

const WTI_30 = makeLightCrude([
  0, 0, 0.01, 0.01, 0.03, 0.03, 0.04, 0.04, 0.05, 0.05, 0.05, 0.05, 0.06, 0.06,
  0.06, 0.06, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04, 0.03, 0.03, 0.025, 0.025,
  0.02, 0.02, 0.01, 0.01,
]);

const ArabLight_30 = makeLightCrude([
  0, 0, 0.01, 0.01, 0.03, 0.03, 0.05, 0.05, 0.06, 0.06, 0.06, 0.06, 0.07, 0.07,
  0.07, 0.07, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04, 0.03, 0.03, 0.02, 0.02, 0.015,
  0.015, 0.005, 0.005,
]);

export const crudeCompositions = {
  "Western Canadian Select": WCS_30_norm,
  Brent: Brent_30,
  "West Texas Intermediate": WTI_30,
  "Arab Light": ArabLight_30,
  "Venezuelan Heavy": VenezuelanHeavy_30_norm,
};
